import React from "react";
import { FiCheck, FiX } from "react-icons/fi";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "../../BaseUI/Modal";
import Button from "../../BaseUI/Button";

/**
 * Shared detail modal shell — plugins supply body content only.
 */
const ApprovalDetailModal = ({
  isOpen,
  onClose,
  title = "Detay",
  header,
  width = "large",
  scrollBehavior,
  children,
  canAct = false,
  readOnly = false,
  approveLabel = "Onayla",
  rejectLabel = "Reddet",
  onApprove,
  onReject,
  approveLoading = false,
}) => (
  <Modal
    isOpen={isOpen}
    onClose={onClose}
    width={width}
    scrollBehavior={scrollBehavior}
  >
    <ModalHeader>{header ?? title}</ModalHeader>
    <ModalBody>{children}</ModalBody>
    <ModalFooter>
      <div className="d-flex gap-2">
        {canAct && !readOnly && (
          <>
            <Button
              appearance="primary-subtle"
              icon={<FiCheck />}
              loading={approveLoading}
              onClick={onApprove}
            >
              {approveLabel}
            </Button>
            <Button
              appearance="danger-subtle"
              icon={<FiX />}
              onClick={onReject}
            >
              {rejectLabel}
            </Button>
          </>
        )}
        <Button appearance="default" onClick={onClose}>
          Kapat
        </Button>
      </div>
    </ModalFooter>
  </Modal>
);

export default ApprovalDetailModal;
